import React, { useState } from 'react';
import SeoPageComponent from '../../components/SeoPageComponent/SeoPageComponent';
import './Home.css';
import logo from '../../assets/icon.png';
import knowledget from '../../assets/knowledge.png';
import RomaniaMap from '../../components/RomaniaMap/RomaniaMap';
import { Link } from 'react-router-dom';
import {
  FaChevronDown,
  FaChevronUp,
  FaUsers,
  FaProjectDiagram,
  FaHandshake,
  FaDollarSign,
} from 'react-icons/fa';

const Home = () => {
  const pageTitle = `Acasă - ${process.env.REACT_APP_NAME} | Portal Achiziții Publice Construcții`;
  const pageDescription = `${process.env.REACT_APP_NAME} este primul portal dedicat achizițiilor publice în domeniul construcțiilor, oferind acces ușor la licitatii, proceduri, proiecte, rapoarte AI si grupari in proiecte.`;
  const pageKeywords =
    'achiziții publice, construcții, licitații, Go4Projects, proiecte construcții, portal achiziții';
  const pageUrl = `${process.env.REACT_APP_DOMAIN}`;

  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: pageTitle,
    description: pageDescription,
    url: pageUrl,
    image: `${process.env.REACT_APP_BASE_URL}/assets/icon.png`,
    publisher: {
      '@type': 'Organization',
      name: 'Go4Projects',
      logo: {
        '@type': 'ImageObject',
        url: `${process.env.REACT_APP_BASE_URL}/assets/icon.png`,
      },
    },
  };

  const [openIndex, setOpenIndex] = useState(null);
  const faqs = [
    {
      question: 'Ce este Go4Projects?',
      answer:
        'Go4Projects este o platformă dedicată îmbunătățirii industriilor de achiziții publice și construcții. Conectăm contractorii și entitățile publice pentru a eficientiza managementul proiectelor, licitațiile și execuția acestora.',
    },
    {
      question: 'Cum mă pot alătura platformei Go4Projects?',
      answer:
        'Te poți înregistra ușor creând un cont pe platforma noastră. Odată înregistrat, poți explora proiectele disponibile, poți depune oferte și accesa instrumentele relevante.',
    },
    {
      question: 'Datele mele sunt în siguranță pe Go4Projects?',
      answer:
        'Da, Go4Projects asigură securitatea de top pentru toate datele tale, utilizând metode avansate de criptare și o infrastructură securizată.',
    },
  ];

  const toggleOpen = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const stats = [
    {
      title: 'Total Users',
      value: '5,230',
      icon: <FaUsers className="text-white text-3xl" />,
      bgColor: 'bg-blue-500',
    },
    {
      title: 'Projects Available',
      value: '1,480',
      icon: <FaProjectDiagram className="text-white text-3xl" />,
      bgColor: 'bg-green-500',
    },
    {
      title: 'Completed Projects',
      value: '3,120',
      icon: <FaHandshake className="text-white text-3xl" />,
      bgColor: 'bg-yellow-500',
    },
    {
      title: 'Total Revenue',
      value: '$2.5M',
      icon: <FaDollarSign className="text-white text-3xl" />,
      bgColor: 'bg-purple-500',
    },
  ];

  return (
    <>
      <SeoPageComponent
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        pageKeywords={pageKeywords}
        pageUrl={pageUrl}
        logoUrl={logo}
      />
      <script type="application/ld+json">{JSON.stringify(schemaData)}</script>

      {/* HERO Section Persuasiv */}
      <section className="py-24 bg-gradient-to-br from-indigo-50 via-white to-blue-100 relative overflow-hidden">
        <div className="container max-w-7xl mx-auto px-6 md:px-12 flex flex-col-reverse md:flex-row items-center gap-10">
          {/* Text Hero */}
          <div className="flex-1 text-center md:text-left">
            <h1 className="text-4xl md:text-5xl xl:text-7xl font-extrabold leading-tight text-gray-800 mb-6">
              Transformă modul în care câștigi{' '}
              <span className="text-indigo-600">licitații</span> și gestionezi{' '}
              <span className="text-green-600">proiecte</span>!
            </h1>
            <p className="text-lg md:text-2xl text-gray-600 mb-10 max-w-2xl mx-auto md:mx-0">
              Descoperă platforma inteligentă care îți aduce{' '}
              <span className="font-semibold text-indigo-500">
                oportunități reale
              </span>
              , automatizări smart și{' '}
              <span className="font-semibold text-green-500">
                avantaj competitiv
              </span>{' '}
              în construcții. Totul, la un click distanță.
            </p>
            <div className="flex flex-wrap gap-4 justify-center md:justify-start">
              <Link
                to="/register"
                className="bg-gradient-to-r from-indigo-500 to-green-500 hover:from-indigo-600 hover:to-green-600 text-white font-bold px-8 py-4 rounded-xl shadow-xl shadow-indigo-200 hover:shadow-green-200 text-lg transition-all duration-300 transform hover:-translate-y-1"
              >
                Începe Gratuit
              </Link>
              <Link
                to="/licitatii"
                className="bg-white border-2 border-indigo-500 text-indigo-600 font-bold px-8 py-4 rounded-xl shadow hover:bg-indigo-50 hover:text-indigo-700 text-lg transition-all duration-300"
              >
                Vezi Licitații
              </Link>
            </div>
          </div>
          {/* Imagine Hero */}
          <div className="flex-1 flex justify-center md:justify-end">
            <img
              src={logo}
              alt="Go4Projects"
              className="w-72 md:w-96 drop-shadow-2xl animate-fade-in"
            />
          </div>
        </div>
      </section>

      {/* Statistici rapide */}
      <section className="bg-white py-12">
        <div className="container max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-indigo-50 to-white rounded-2xl shadow-lg p-6 flex flex-col items-center group hover:scale-105 hover:shadow-indigo-200 transition-all duration-300 border-t-4 border-indigo-400"
            >
              <div
                className={`p-4 rounded-full mb-3 text-3xl ${stat.bgColor} shadow-xl`}
              >
                {stat.icon}
              </div>
              <div className="text-center">
                <h3 className="text-lg font-semibold text-gray-700">
                  {stat.title}
                </h3>
                <p className="text-3xl font-bold text-indigo-600 group-hover:text-green-600 transition-all">
                  {stat.value}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Licitații Zilnice */}
      <section className="bg-gradient-to-br from-white to-indigo-50 py-20">
        <div className="container max-w-5xl mx-auto">
          <h2 className="text-center text-4xl md:text-5xl font-extrabold text-gray-800 mb-4 relative w-fit mx-auto after:absolute after:w-4/5 after:-bottom-3 after:left-1/2 after:-translate-x-1/2 after:border-b-4 after:border-indigo-500 after:border-double">
            Licitații zilnice, mereu actualizate
          </h2>
          <p className="text-center text-gray-500 mb-8 text-lg max-w-2xl mx-auto">
            Fii primul care află de oportunități noi! Platforma noastră
            actualizează automat licitațiile publice din construcții, ca tu să
            nu ratezi nicio șansă de succes.
          </p>
          <RomaniaMap />
        </div>
      </section>

      {/* Avantaje platformă */}
      <section className="bg-white py-20">
        <div className="container max-w-6xl mx-auto">
          <h2 className="text-center text-4xl md:text-5xl font-extrabold text-gray-800 mb-10">
            De ce să alegi Go4Projects?
          </h2>
          <div className="flex flex-wrap items-center justify-center gap-8">
            <div className="bg-gradient-to-br from-indigo-50 to-white shadow-lg p-8 rounded-2xl w-80 flex flex-col items-center hover:scale-105 hover:shadow-indigo-200 transition-all">
              <span className="w-16 h-16 flex items-center justify-center rounded-full bg-indigo-100 text-3xl mb-4">
                🚀
              </span>
              <h4 className="text-2xl font-bold text-indigo-600 mb-2">
                Automatizare Inteligentă
              </h4>
              <p className="text-gray-600 text-center">
                Primești alerte și rapoarte personalizate, fără efort. Platforma
                lucrează pentru tine!
              </p>
            </div>
            <div className="bg-gradient-to-br from-green-50 to-white shadow-lg p-8 rounded-2xl w-80 flex flex-col items-center hover:scale-105 hover:shadow-green-200 transition-all">
              <span className="w-16 h-16 flex items-center justify-center rounded-full bg-green-100 text-3xl mb-4">
                💡
              </span>
              <h4 className="text-2xl font-bold text-green-600 mb-2">
                Decizii Smart
              </h4>
              <p className="text-gray-600 text-center">
                Accesezi analize avansate și date relevante pentru a lua decizii
                rapide și profitabile.
              </p>
            </div>
            <div className="bg-gradient-to-br from-yellow-50 to-white shadow-lg p-8 rounded-2xl w-80 flex flex-col items-center hover:scale-105 hover:shadow-yellow-200 transition-all">
              <span className="w-16 h-16 flex items-center justify-center rounded-full bg-yellow-100 text-3xl mb-4">
                🤝
              </span>
              <h4 className="text-2xl font-bold text-yellow-600 mb-2">
                Colaborare Simplificată
              </h4>
              <p className="text-gray-600 text-center">
                Lucrezi ușor cu echipa și partenerii, totul într-un singur loc,
                fără bătăi de cap.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section className="bg-gradient-to-r from-indigo-500 to-green-500 py-20">
        <div className="container max-w-4xl mx-auto text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-white mb-6 drop-shadow-lg">
            Ești gata să câștigi mai mult și mai ușor?
          </h2>
          <p className="text-white text-lg mb-10 max-w-2xl mx-auto">
            Creează-ți contul gratuit și descoperă cum Go4Projects îți poate
            transforma afacerea în construcții. Fii cu un pas înaintea
            concurenței!
          </p>
          <Link
            to="/register"
            className="bg-white text-indigo-600 font-bold px-10 py-4 rounded-xl shadow-xl text-xl hover:bg-indigo-50 hover:text-green-600 transition-all duration-300"
          >
            Creează cont gratuit
          </Link>
        </div>
      </section>

      {/* FAQ */}
      <section className="bg-white py-20">
        <div className="container max-w-5xl mx-auto">
          <h2 className="text-center text-4xl md:text-5xl font-extrabold text-gray-800 mb-8">
            Întrebări frecvente
          </h2>
          <div className="mt-10 max-w-4xl mx-auto">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="mb-4 bg-gradient-to-br from-indigo-50 to-white rounded-xl border border-indigo-100 shadow hover:shadow-indigo-200 transition-all"
              >
                <button
                  onClick={() => toggleOpen(index)}
                  className="w-full text-left text-lg font-semibold p-5 hover:bg-indigo-100 outline-none duration-300 flex justify-between items-center"
                >
                  <span>{faq.question}</span>
                  {openIndex === index ? (
                    <FaChevronUp className="text-indigo-500" />
                  ) : (
                    <FaChevronDown className="text-indigo-500" />
                  )}
                </button>
                <div
                  className={`${
                    openIndex === index ? 'max-h-screen' : 'max-h-0'
                  } overflow-hidden transition-all duration-300 ease-in-out`}
                >
                  <p className="p-5 text-gray-700">{faq.answer}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
